export const features = [
  {
    id: 1,
    title: "Smart Field Replacement",
    description: "Instantly merge Salesforce fields into your documents—no manual edits, no errors.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Bulk Document Processing",
    description: "Generate contracts, invoices, or reports for many customers at once—fast, accurate, and consistent.",
    icon: "Layers"
  },
  {
    id: 3,
    title: "Built for Salesforce, Powered by the Cloud",
    description: "QuillStudio lives inside Salesforce for setup and usage, with secure cloud processing for fast, reliable PDF generation.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Template Management",
    description: "Build reusable templates once and use them forever—streamlining every contract, quote, or report.",
    icon: "FileCheck"
  },
  {
    id: 5,
    title: "Custom Field Mapping",
    description: "Flexibly map any Salesforce field—even custom objects and formulas—directly into your documents.",
    icon: "Link"
  },
  {
    id: 6,
    title: "Professional PDF Output",
    description: "Get polished PDFs every time—your fonts, layouts, and branding perfectly preserved.",
    icon: "Download"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Upload Your Template",
    description: "Add Salesforce tags (e.g., {{Account.Name}}, {{Contact.Email}}) to your Word doc and upload it to QuillStudio."
  },
  {
    step: 2,
    title: "Select Records",
    description: "Pick single or bulk Salesforce records to merge with your template."
  },
  {
    step: 3,
    title: "Generate PDFs",
    description: "Click generate and instantly get polished PDFs filled with live Salesforce data."
  }
];

export const benefits = [
  {
    title: "Save Hours Every Week",
    description:
      "Eliminate manual copy-paste and turn document generation from hours into minutes."
  },
  {
    title: "No More Data Entry Errors",
    description:
      "Merge fields pull live Salesforce data into your templates, keeping documents accurate every time."
  },
  {
    title: "Scale Effortlessly",
    description:
      "Generate documents for one record or run bulk jobs—hundreds of personalized PDFs in minutes."
  },
  {
    title: "Works Natively in Salesforce",
    description:
      "No exports or external tools. QuillStudio runs seamlessly inside your Salesforce org."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Sales Operations Manager",
    company: "TechCorp Solutions",
    content: "QuillStudio has revolutionized our contract generation process. What used to take our team 2 days now takes 20 minutes.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Salesforce Administrator", 
    company: "Global Enterprises",
    content: "The seamless integration with Salesforce made adoption incredibly easy. Our sales team loves how simple it is to generate proposals.",
    rating: 5
  },
  {
    id: 3,
    name: "Lisa Rodriguez",
    role: "Operations Director",
    company: "StartupHub Inc",
    content: "We generate 200+ personalized documents monthly now. The accuracy and speed improvements have been game-changing.",
    rating: 5
  }
];

export const stats = [
  {
    number: "50,000+",
    label: "Documents Generated"
  },
  {
    number: "500+",
    label: "Happy Customers"
  },
  {
    number: "99.9%",
    label: "Uptime"
  },
  {
    number: "24/7",
    label: "Support"
  }
];

export const useCases = [
  "Contract Generation",
  "Invoice Creation", 
  "Proposal Documents",
  "Reports & Analytics",
  "Customer Communications",
  "Legal Documents",
  "HR Paperwork",
  "Marketing Materials"
];